import { h, Component } from 'preact';
import { route } from 'preact-router'
import { MkComponent } from 'lib/mkjs/mkcomponent';
import Markdown from 'preact-markdown';
import { Loading } from 'lib/mkjs';
import ContactImport from "entities/contactimport";
import style from './style.less';

function csvToArrayOfObjects(csv) {
	let table = csvTo2dArray(csv).filter(row=>row.some(elt=>elt.trim().length > 0));
	let header = table[0];
	return table.filter((row, i)=>(i>0)).map(row=>{
		let obj = {};
		header.forEach((cell, i)=>{
			if (row[i] && row[i].trim().length > 0) {
				obj[header[i].trim()] = row[i];
			}
		})
		return obj;
	})

	let maxLengthRow = table.reduce((acc, row)=>(acc.length >= row.length ? acc : row), []);
	let len = maxLengthRow.length;
	return table.map(row=>{
		return row.concat(new Array(len-row.length).fill(''))
	})
}

//from https://stackoverflow.com/questions/1293147/javascript-code-to-parse-csv-data
function csvTo2dArray( strData, strDelimiter=',' ){
	//pad out string to simplify regexes
	strData = "\n" + strData + "\n";
	// Create a regular expression to parse the CSV values.
	var objPattern = new RegExp(
			(
					// Delimiters.
					"(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
					// Quoted fields.
					"(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
					// Standard fields.
					"([^\"\\" + strDelimiter + "\\r\\n]*))"
			),
			"gi"
			);
	var arrData = [[]];
	if (strData.trim().length === 0) {
		return arrData;
	}
	var arrMatches = null;
	// Keep looping over the regular expression matches
	// until we can no longer find a match.
	while ( arrMatches = objPattern.exec( strData )){
		// Get the delimiter that was found.
		var strMatchedDelimiter = arrMatches[ 1 ];
		// Check to see if the given delimiter has a length
		// (is not the start of string) and if it matches
		// field delimiter. If id does not, then we know
		// that this delimiter is a row delimiter.
		if (
			strMatchedDelimiter.length &&
			(strMatchedDelimiter != strDelimiter)
			){
			// Since we have reached a new row of data,
			// add an empty row to our data array.
			arrData.push( [] );
		}
		// Now that we have our delimiter out of the way,
		// let's check to see which kind of value we
		// captured (quoted or unquoted).
		if (arrMatches[ 2 ]){
			// We found a quoted value. When we capture
			// this value, unescape any double quotes.
			var strMatchedValue = arrMatches[ 2 ].replace(
					new RegExp( "\"\"", "g" ),
					"\""
					);
		} else {
			// We found a non-quoted value.
			var strMatchedValue = arrMatches[ 3 ];
		}
		// Now that we have our value string, let's add
		// it to the data array.
		arrData[ arrData.length - 1 ].push( strMatchedValue );
	}
	// Return the parsed data.
	return( arrData );
}

const TRANSLATE_GOOGLE_CONTACT = {
	"Name": "name",
	"E-mail 1 - Value": "email",
	"Phone 1 - Value": "phone",
	"Address 1 - Street": "address1",
	"Address 1 - Extended Address": "address2",
	"Address 1 - City": "city",
	"Address 1 - Region": "state",
	"Address 1 - Postal Code": "zip",

	"Email": "email",
	"Phone": "phone",
	"Address 1": "address1",
	"Address 2": "address2",
	"City": "city",
	"State/Territory": "state",
	"Zip/Postal Code": "zip"
}

function googleContactToContactInfo(gc) {
	return Object.keys(TRANSLATE_GOOGLE_CONTACT).reduce((o, key) => ({ ...o, [TRANSLATE_GOOGLE_CONTACT[key]]: gc[key] || o[[TRANSLATE_GOOGLE_CONTACT[key]]]}), {})
}

export class ImportStart extends Component {
	render() {
		return <section>
			<h1>Build Your Addy</h1>
<Markdown markdown={`
### Upload your address list.
1. Download our <a href="${window.location.origin}/assets/static/addy-contact-import.csv" download="addy-contact-import.csv">contacts spreadsheet template</a>.
1. Collect your contacts and add them to the spreadsheet.
2. Save file as \`.CSV\`.
3. Upload the \`.CSV\` file below and click "Create"!

#### *or*

### Start building your address list with your Google contacts

1. Open the <a href="https://contacts.google.com/" target="_blank">Google Contacts app</a> (accessible via 9 dots on the upper right corner of gmail)
2. Click "export".
3. Choose a list (we recommend "frequently contacted") and then "export as Google CSV".
4. Upload the \`.CSV\` file below and click "Create"!
`}/>
	<CsvImporter {...this.props} onCreate={()=>route('/')} />
</section>
	}
}

export class CsvImporter extends ContactImport {

  getName(){
    return 'contactImport'
  }

	getEditTitle(isUpdate, entity) {
		return (isUpdate ? 'update ' : '') + 'import contacts';
	}

	generateContactImport(rawContacts) {

		let contactList = rawContacts.map(contact=>{
			return {
			owner: {
				id: this.props.contactEntity.id
			},
			info: googleContactToContactInfo(contact)
		}});

		return {
			owner: this.props.contactEntity,
			importedContacts: contactList
		}
	}

	getCreateFields() {
		let fields = {};
		// fields.csv = {
		// 	"type" : "string",
		// 	"title" : "CSV Export of Google Contact List",
		// 	"multiline": true,
		// 	"className": "text-monospace",
		// 	"default": RAW_CSV
		// }
		fields.file = {
			"title": "Google Contacts CSV Export File",
			"type": "object",
			"fileupload": true,
			"fileReadMethod": "readAsText"
		}

		return fields;
	}

	prepareCreate(subject) {
		let csv = subject.file ? subject.file.fileContent : '';
		let contacts = csvToArrayOfObjects(csv);
		let impt = this.generateContactImport(contacts);
		return impt;
	}

	getCreateFooter(subject) {
		if (this.props.contactEntity) {
			let contacts = this.prepareCreate(subject).importedContacts;
			return <div class="shadow-lg my-3 bg-white rounded px-4 py-3">
				{contacts.map(c=><ContactInfoSummaryView subject={c} />)}
			</div>
		} else {
			return <Loading />
		}
	}

}

class ContactInfoSummaryView extends Component {
	render() {
		let rows = this.props.rows || 2;
		let info = this.props.subject.info;
		console.log('!!!!info',info);
		return <div class={style.contact_summary}>
			<div class={style.contact_summary_name}>{info.name}</div>
			{Object.keys(info).filter(key=>key != 'name' && info[key]).slice(0,2).map(key=>{
				return <div class={style.contact_summary_field}>{info[key]}</div>
			})}
		</div>
	}
}

const RAW_CSV=
`Name,Given Name,Additional Name,Family Name,Yomi Name,Given Name Yomi,Additional Name Yomi,Family Name Yomi,Name Prefix,Name Suffix,Initials,Nickname,Short Name,Maiden Name,Birthday,Gender,Location,Billing Information,Directory Server,Mileage,Occupation,Hobby,Sensitivity,Priority,Subject,Notes,Language,Photo,Group Membership,E-mail 1 - Type,E-mail 1 - Value,E-mail 2 - Type,E-mail 2 - Value,IM 1 - Type,IM 1 - Service,IM 1 - Value,Phone 1 - Type,Phone 1 - Value,Phone 2 - Type,Phone 2 - Value,Phone 3 - Type,Phone 3 - Value,Address 1 - Type,Address 1 - Formatted,Address 1 - Street,Address 1 - City,Address 1 - PO Box,Address 1 - Region,Address 1 - Postal Code,Address 1 - Country,Address 1 - Extended Address,Organization 1 - Type,Organization 1 - Name,Organization 1 - Yomi Name,Organization 1 - Title,Organization 1 - Department,Organization 1 - Symbol,Organization 1 - Location,Organization 1 - Job Description,Website 1 - Type,Website 1 - Value
Test Contact,,,,,,,,,,,,,,,,,,,,,,,,,,,,* myContacts,,,,,,,,Mobile,(000)000-0000,,,,,,,,,,,,,,,,,,,,,,,
`



// WEBPACK FOOTER //
// ./components/elements/importer/index.js